export default __webpack_public_path__ + "static/media/img--design-3.c5bb8a17.jpg";